import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  BRAND_AUTOS,
  BRAND_PAPYRUS_CONSUMO,
  FORM_AUTO,
  FORM_BP,
  FORM_CONSUMO,
  FORM_MG,
  FORM_MG_NO_SHOP,
  PENDIENTES_DE_DATOS,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_VIEW,
  REQUEST_OBSERVATIONS,
  VERSION_PRESTAMO_REESTRUCTURADO,
} from '@app/@core/constants/requests.constants';
import { PrintStore } from '@app/@shared';
import {
  AuthorizationDTO,
  Operation,
  PrintContractDTO,
  RequestFormDTO,
  StatesFieldsFrontDTO,
} from '@app/requests/model/requests-model';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { DOWNLOAD } from '@app/@core/constants/training.constants';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { PanelStore } from '@app/requests/panel/panel.store';
import { FINANCIAL_PRODUCT } from '@app/@core/constants/logalty-digital-signature.constants';

@Component({
  selector: 'scf-request-observations',
  templateUrl: './request-observations.component.html',
  styleUrls: ['./request-observations.component.scss'],
})
export class RequestObservationsComponent implements OnInit {
  public observationsForm: FormGroup;
  @Input() public mode: string = 'new';
  @Input() public isAuto: boolean = false;
  @Input() public observations: any = null;
  @Input() state: CommonDataDTO;
  @Input() public request: any = null;
  @Input() public requestType: string = null;
  @Input('operative') set operative(data: any) {
    console.log(data);
    if (data) {
      if (data === 'EIC' && this.requestStore.listaFormulariosConsumo.includes(this.observationsForm)) {
        this.requestStore.listaFormulariosConsumo[REQUEST_OBSERVATIONS] = null;
      } else if (data !== 'EIC' && !this.requestStore.listaFormulariosConsumo.includes(this.observationsForm)) {
        this.requestStore.setFormularioConsumo(this.observationsForm, REQUEST_OBSERVATIONS);
      }
    }
  }
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public isFinishedLoading = new EventEmitter<any>();

  checked: boolean = false;
  showObservations: boolean = false;
  public operation: Operation;

  //PE_725 Fenix
  fieldsDisabled: StatesFieldsFrontDTO[];

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private printStore: PrintStore,
    private dialog: MatDialog,
    private panelStore: PanelStore
  ) {
    this.createForm();
  }

  ngOnInit() {
    if (this.requestStore.getMarcaFormulario() === FORM_BP) {
      this.requestStore.setFormularioBonpreu(this.observationsForm, REQUEST_OBSERVATIONS);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG_NO_SHOP) {
      this.requestStore.setFormularioMangoNoShopping(this.observationsForm, REQUEST_OBSERVATIONS);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.observationsForm, REQUEST_OBSERVATIONS);
    } else if (this.requestStore.getMarcaFormulario() === FORM_CONSUMO) {
      this.requestStore.setFormularioConsumo(this.observationsForm, REQUEST_OBSERVATIONS);
    } else if (this.requestStore.getMarcaFormulario() === FORM_AUTO) {
      this.requestStore.setFormularioAutos(this.observationsForm, REQUEST_OBSERVATIONS);
    }

    this.observationsForm.statusChanges.subscribe(() => {
      this.changeContinueStatus.emit({ form: <FormGroup>this.observationsForm, id: REQUEST_OBSERVATIONS });
    });

    if (this.mode === REQUEST_MODE_VIEW) {
      if (this.state.id !== PENDIENTES_DE_DATOS) {
        this.observationsForm.disable();
      }
      this.showObservations = true;
      this.checked = true;
      this.setValuesToForm();
    } else if (this.mode === REQUEST_MODE_EDIT) {
      this.setValuesToForm();
      this.showObservations = false;
    }

    this.isFinishedLoading.emit({ formID: REQUEST_OBSERVATIONS, value: true });
  }

  ngAfterContentChecked() {
    //PE_725 Fenix
    if (this.mode === REQUEST_MODE_EDIT && this.request !== null && this.request.fieldsDisable !== null) {
      this.fieldsDisabled = this.request.fieldsDisable;
      this.disableFieldsByCore();
    }
  }

  private createForm() {
    this.observationsForm = this.formBuilder.group({
      observations: [''],
      checkObservations: [''],
    });
  }

  setValuesToForm() {
    this.observationsForm.controls.observations.setValue(this.observations);
  }

  public download() {
    this.operation = this.panelStore.getOperationToShow();
    const operationMapper: any = this.operation;
    console.log('request:', this.request);
    if (
      (!this.isAuto && this.requestType != 'C' && this.requestType != 'GS' && this.requestType != 'REP') ||
      this.mode === 'new'
    ) {
      let RequestAuthorization: AuthorizationDTO;
      this.requestStore.numIntervinientes = this.request.participants.length;
      RequestAuthorization = this.printStore.convertAuthorizationToHolderDTO(this.request, true);

      if (RequestAuthorization) {
        this.printStore.downloadAuthorization(RequestAuthorization, DOWNLOAD);
      }
    } else {
      this.requestStore.downloadPapyrus(
        this.isAuto,
        this.mode,
        this.request,
        this.operative,
        this.requestType,
        this.operation
      );
    }
  }
  private disableFieldsByCore() {
    if (this.fieldsDisabled !== null && this.fieldsDisabled !== undefined) {
      const form = this.observationsForm;
      this.fieldsDisabled.forEach((field) => {
        const toDisable = form.get(field.campoName);
        if (toDisable !== null && toDisable !== undefined) {
          toDisable.disable();
        }
      });
    }
  }
}
